import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PartnerCUResponseDto } from 'src/app/modules/admin-functions/topcon-configuration/dtos/partner-cu.dto';
import { environment } from 'src/environments/environment';
import { AuditTrailRequestDto } from '../dtos/request-dto/audit-trail-request.dto';
import { AuditTrailResponseDto } from '../dtos/response-dto/audit-trail-response-dto';
import { ReportSelectionDTO } from '../dtos/response-dto/report-selection-response-dto';

@Injectable({
    providedIn: 'root'
})
export class AuditTrailService {
  private readonly PARTNER_GET_ENDPOINT = environment.baseUrl + 'Configuration/partners';
  private readonly REPORT_AUDIT = environment.baseUrl + 'Report/audit';
  private readonly SELECTION_ENDPOINT = environment.baseUrl + 'Report/selection'
  public constructor(private http: HttpClient) { }

  public getPartners(): Observable<PartnerCUResponseDto> {
      return this.http.get<PartnerCUResponseDto>(this.PARTNER_GET_ENDPOINT);
  }

  public postConfigurationReport(data: AuditTrailRequestDto): Observable<AuditTrailResponseDto> {
      return this.http.post<AuditTrailResponseDto>(this.REPORT_AUDIT, data);
  }

  public getReportSelection(): Observable<ReportSelectionDTO> {
      return this.http.get<ReportSelectionDTO>(this.SELECTION_ENDPOINT);
  }
}
